<template>
  <div class="element-label__ai-edit-wrapper">
    <div>{{ t('author.autoPopulate') }}</div>
    <BbSwitch v-model="lockedValue" :items="lockedValues" class="element-label__switch" />
  </div>
</template>
<script>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useElementHighlight, useWesley } from '@anthill-modules/wesley-components';
import useDocumentEditor from '~/composables/useDocumentEditor';

export default {
  setup() {
    const { sendMessage: sendMessageToDocument } = useWesley();
    const { updateEditorSelectableElementsData } = useDocumentEditor();
    const { selectedParent: selectedLayout } = useElementHighlight();
    const { t } = useI18n();

    const lockedValue = ref(
      selectedLayout.value && selectedLayout.value.attributes?.['data-ant-locked'] !== 'true' ? 1 : 0,
    );
    const lockedValues = [
      {
        title: t('common.no'),
        value: 0,
      },
      {
        title: t('common.yes'),
        value: 1,
      },
    ];

    watch(lockedValue, () => {
      const layoutPath = selectedLayout.value?.cssPath;
      if (layoutPath) {
        sendMessageToDocument({
          method: 'updateAttribute',
          params: {
            query: layoutPath,
            attr: 'data-ant-locked',
            value: lockedValue.value !== 1,
          },
        });
        updateEditorSelectableElementsData();
      }
    });

    return {
      lockedValue,
      lockedValues,
      t,
    };
  },
};
</script>

<style lang="scss" scoped>
.element-label {
  &__ai-edit-wrapper {
    display: flex;
    gap: $bb-spacing-2;
    align-items: center;
    font-weight: 500;
    z-index: 2;
  }

  &__switch {
    pointer-events: inherit;
    width: 100px !important;
    padding: 2px 0;
    background: transparent;

    :deep(.switch-item) {
      height: $bb-spacing-4 !important;
      padding: 0 !important;
    }

    :deep(.switch-item .v-slide-group__container .v-slide-group__content) {
      button {
        height: 14px;
      }
    }

    :deep(.switch-item .v-slide-group__container .v-slide-group__content .v-tab--selected) {
      background-color: $bb-primary-3 !important;
    }
  }
}
</style>
